import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FranchiseForm from '../components/FranchiseForm';

const Franchise: React.FC = () => {
  const { t } = useTranslation();

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Franchise Opportunity | Aswad Amruttulya - Start Your Tea Business</title>
        <meta name="description" content="Start your own Aswad Amruttulya tea franchise with low investment and high returns. Complete business support, training, and a proven brand. Apply now!" />
        <meta property="og:title" content="Franchise Opportunity | Aswad Amruttulya" />
        <meta property="og:description" content="Low investment, high demand tea franchise. Get complete business support and training to start your own Aswad Amruttulya outlet." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://aswadamruttulya.com/franchise" />
      </Helmet>
      <Header />
      <section className="page-section franchise-page" style={{ paddingBottom: '0' }}>
        <div className="container">
          <div className="page-hero-banner">
            <span className="page-badge">{t('franchise_heading')}</span>
            <h1 className="page-hero-title">{t('franchise_title')}</h1>
            <p className="page-hero-desc">{t('franchise_subtitle')}</p>
          </div>
          <div className="grid grid-3 franchise-grid">
            <div className="card franchise-info-card">
              <div className="card-icon">🏠</div>
              <h3>{t('shop_requirement')}</h3>
              <p>{t('shop_requirement_value')}</p>
            </div>
            <div className="card franchise-info-card highlight">
              <div className="card-icon">🌟</div>
              <h3>{t('free_franchise_title')}</h3>
              <p>{t('free_franchise_text')}</p>
            </div>
            <div className="card franchise-info-card">
              <div className="card-icon">🚀</div>
              <h3>{t('franchise_setup_title')}</h3>
              <p>{t('franchise_setup_text')}</p>
            </div>
          </div>
        </div>
      </section>
      
      <FranchiseForm />
      
      <Footer />
    </div>
  );
};

export default Franchise;